// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-select {
   display: inline-block;
   width: 250px;
   padding: 5px;
   border-bottom: 2px solid #9999999c;
   margin-left: 12px;
   margin-top: 5px;
}

.validate-error {
   border-bottom: 2px solid rgba(255, 0, 15, 0.61);
}

/* For device */
@media (min-width: 0px) and (max-width: 414px) {
   .mat-select {
      width: 180px;
   }
}

@media (min-width: 414px) and (max-width: 766px) {
   .mat-select {
      width: 200px;
   }
}

@media (min-width: 767px) and (max-width: 900px) {
   /* For mobile phones: */
   .mat-select {
      width: 200px;
   }
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

select {
   height: 30px;
   border-style: solid;
   border-width: 1px;
   border-color: rgba(0, 0, 0, 0.12);
   cursor: unset;
   padding: 5px 10px;
   margin: 4px 10px 10px 12px !important;
}

select:focus, select:active, select:hover {
   outline-color: rgba(6, 6, 6, 0.12) !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/dropdown/dropdown.component.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,YAAY;GACZ,YAAY;GACZ,kCAAkC;GAClC,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,+CAA+C;AAClD;;AAEA,eAAe;AACf;GACG;MACG,YAAY;GACf;AACH;;AAEA;GACG;MACG,YAAY;GACf;AACH;;AAEA;GACG,uBAAuB;GACvB;MACG,YAAY;GACf;AACH;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,iBAAiB;GACjB,iCAAiC;GACjC,aAAa;GACb,iBAAiB;GACjB,qCAAqC;AACxC;;AAEA;GACG,6CAA6C;AAChD","sourcesContent":[".mat-select {\n   display: inline-block;\n   width: 250px;\n   padding: 5px;\n   border-bottom: 2px solid #9999999c;\n   margin-left: 12px;\n   margin-top: 5px;\n}\n\n.validate-error {\n   border-bottom: 2px solid rgba(255, 0, 15, 0.61);\n}\n\n/* For device */\n@media (min-width: 0px) and (max-width: 414px) {\n   .mat-select {\n      width: 180px;\n   }\n}\n\n@media (min-width: 414px) and (max-width: 766px) {\n   .mat-select {\n      width: 200px;\n   }\n}\n\n@media (min-width: 767px) and (max-width: 900px) {\n   /* For mobile phones: */\n   .mat-select {\n      width: 200px;\n   }\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\nselect {\n   height: 30px;\n   border-style: solid;\n   border-width: 1px;\n   border-color: rgba(0, 0, 0, 0.12);\n   cursor: unset;\n   padding: 5px 10px;\n   margin: 4px 10px 10px 12px !important;\n}\n\nselect:focus, select:active, select:hover {\n   outline-color: rgba(6, 6, 6, 0.12) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
